import { jsx as A } from "react/jsx-runtime";
import { createContext as E, useState as s, useMemo as F, useContext as K } from "react";
import { DEFAULT_BRANCH_DATES as p } from "@lumirental/lumi-web-shared/lib/constants/date/DEFAULT_BRANCH_DATES";
const d = E(null), O = ({
  children: e,
  appEnv: S,
  isMobile: x,
  sections: r,
  faqs: P,
  countryList: t,
  selectedCountry: n,
  setSelectedCountry: R
}) => {
  const [c, D] = s(
    p.PICKUP
  ), [a, C] = s(
    p.DROPOFF
  ), [m, b] = s(""), [f, l] = s(!1), o = r.find(
    (u) => {
      var i;
      return ((i = u == null ? void 0 : u.mappingKey) == null ? void 0 : i.uiKey) === "our_routes";
    }
  ), h = (o == null ? void 0 : o.list) ?? [], v = () => {
    l(!0);
  }, B = () => {
    l(!1);
  }, w = F(
    () => ({
      appEnv: S,
      isMobile: x,
      sections: r,
      faqs: P,
      routeList: h,
      countryList: t,
      selectedCountry: n,
      setSelectedCountry: R,
      pickupDate: c,
      setPickUpDate: D,
      dropoffDate: a,
      setDropOffDate: C,
      selectedRoute: m,
      setSelectedRoute: b,
      submitSuccess: f,
      showSubmitSuccess: v,
      hideSubmitSuccess: B
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      t == null ? void 0 : t.length,
      n,
      c,
      a,
      m,
      f
    ]
  );
  return /* @__PURE__ */ A(d.Provider, { value: w, children: e });
}, k = O, T = () => {
  const e = K(d);
  if (!e)
    throw new Error(
      "BusRental context must be used within a BusRental Provider"
    );
  return e;
};
export {
  k as default,
  T as useBusRentalContext
};
